module.exports = __webpack_public_path__ + "static/media/Gretoon-01.ddfdbce8.svg";